
import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import { Badge } from '@/components/ui/badge';
import { createConsumerIcon, getConsumerStatusColor } from './utils';
import { Consumer } from './types';

interface ConsumerMarkerProps {
  consumer: Consumer;
}

const ConsumerMarker: React.FC<ConsumerMarkerProps> = ({ consumer }) => {
  const position: [number, number] = [consumer.location.lat, consumer.location.lng];
  const icon = createConsumerIcon(consumer.status);
  
  const statusBadgeColor = () => {
    switch (consumer.status) {
      case 'active': return 'bg-green-500';
      case 'inactive': return 'bg-gray-500';
      case 'defaulter': return 'bg-red-500';
      default: return 'bg-gray-500';
    }
  };

  return (
    <Marker position={position} icon={icon}>
      <Popup>
        <div className="p-1 consumer-popup">
          <div className="flex items-start justify-between mb-2">
            <h3 className="font-semibold text-sm">{consumer.name}</h3>
            <Badge className={statusBadgeColor()}>
              {consumer.status.charAt(0).toUpperCase() + consumer.status.slice(1)}
            </Badge>
          </div>
          
          <div className="text-xs text-gray-600 mb-2">ID: {consumer.id}</div>
          
          <div className="text-xs text-gray-600 mb-2">
            {consumer.address}
          </div>
          
          <div className="text-xs text-gray-600 mb-2">
            Coordinates: {consumer.location.lat.toFixed(6)}, {consumer.location.lng.toFixed(6)}
          </div>
          
          <div className="text-xs font-medium mt-2">
            Average Consumption: {consumer.consumption} units
          </div>
        </div>
      </Popup>
    </Marker>
  );
};

export default ConsumerMarker;
